/** @format */

import { PrimaryButton } from '@/components/page/PageListing/components/shared.style';
import styled from 'styled-components';
import { SwiperButtonNext, SwiperButtonPrev, SwiperNavigationButton } from '../GalleryCarousel.style';
import { Wrapper as PriceWrapper } from '../Price.style';
import { Title } from '../index.style';

export const Wrapper = styled.div`
  position: absolute;
  inset: 0;
  background: ${({ theme }) => theme.colors.joivy.white};

  display: flex;
  flex-direction: column;

  --padding-inline: 5rem;

  @media screen and (max-width: 1160px) {
    --padding-inline: 1rem;
  }

  a {
    display: inline-block;
    text-decoration: none;
    padding: 0.625rem 1.125rem;
  }
`;

export const Header = styled.div`
  padding: 1rem var(--padding-inline);
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--gray-300, #d0d5dd);
  background: var(--gray-50, #f9fafb);

  ${Title} {
    margin: 0;

    @media screen and (min-width: 1161px) {
      font-size: 1.25rem;
    }
  }
`;

export const HeaderDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-top: 0.5rem;

  .divider {
    display: inline-block;
    width: 1px;
    align-self: stretch;
    background: var(--gray-300, #d0d5dd);
  }

  @media screen and (max-width: 1160px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;

    ${PriceWrapper} {
      align-self: flex-start;
    }

    .divider {
      display: none;
    }
  }
`;

export const HeaderRight = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 2rem;
`;

export const CloseButton = styled.button`
  width: 2.875rem;
  height: 2.875rem;
  display: grid;
  place-items: center;
  background: var(--gray-100, #f2f4f7);
  border: none;
  border-radius: 50%;

  cursor: pointer;
  transition: all 0.5s cubic-bezier(0.36, 0.33, 0, 1) 0s;

  &:hover,
  &:focus,
  &:active {
    background: var(--gray-200, #eaecf0);
  }
`;

export const Content = styled.div`
  position: relative;
  padding: 2rem var(--padding-inline);
  flex: 1;
  min-height: 0;

  @media screen and (max-width: 1160px) {
    padding: 0;
  }

  .swiper {
    width: 83%;
    height: 100%;

    @media screen and (max-width: 1160px) {
      width: 100%;
    }
  }

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-slide .slide-content {
    width: 100%;
    height: 100%;

    & > * {
      margin: auto;
    }

    @media screen and (max-width: 1160px) {
      display: flex;
    }
  }

  .swiper-slide img {
    display: block;
    max-width: 100%;
    width: auto;
    height: 100%;
    object-fit: contain;

    @media screen and (max-width: 1160px) {
      width: 100%;
      height: auto;
    }
  }

  ${SwiperNavigationButton} {
    width: 2.875rem;
    height: 2.875rem;
    padding: 0.48rem;
    opacity: 0.86;
    box-shadow: 0px 1px 3px 0px rgba(16, 24, 40, 0.1), 0px 1px 2px 0px rgba(16, 24, 40, 0.06);
    transition: all 0.5s cubic-bezier(0.36, 0.33, 0, 1) 0s;
    cursor: pointer;
    background: ${({ theme }) => theme.colors.joivy.white};

    &:hover,
    &:focus,
    &:active {
      opacity: 1;
    }
  }

  ${SwiperButtonPrev} {
    left: 5rem;
  }

  ${SwiperButtonNext} {
    right: 5rem;
  }
`;

export const Footer = styled.div`
  padding: 1rem var(--padding-inline);
  border-top: 1px solid var(--gray-300, #d0d5dd);
  background: var(--gray-50, #f9fafb);

  display: flex;
  align-items: center;
  justify-content: center;

  position: relative;

  @media screen and (max-width: 1160px) {
    display: grid;
    gap: 0.63rem;
    align-items: stretch;
    justify-content: unset;

    button {
      flex-grow: 1;
    }
    a {
      width: 100%;
      text-align: center;
    }
  }
`;

export const TabInfoWrapper = styled.div`
  color: var(--gray-900, #101828);
  font-size: 1rem;
  line-height: 1.5;

  & > * {
    margin: 0;
  }

  .title {
    font-weight: 500;
  }

  .info {
    font-weight: 300;
  }

  position: absolute;
  left: var(--padding-inline);
  top: 50%;
  transform: translateY(-50%);

  @media screen and (max-width: 1160px) {
    bottom: 1.75rem;
    z-index: 1;
    border-radius: 0.25rem;
    background: rgba(255, 255, 255, 0.87);
    padding: 0.25rem 0.5rem;
    top: unset;
    transform: unset;
  }
`;

export const ModalVRContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const Frame = styled.iframe`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
`;

export const TabControls = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  button {
    border-top: 1px solid var(--gray-300, #d0d5dd);
    border-bottom: 1px solid var(--gray-300, #d0d5dd);
    border-right: 1px solid var(--gray-300, #d0d5dd);
  }

  button:first-child {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
    border-left: 1px solid var(--gray-300, #d0d5dd);
  }

  button:last-child {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
`;

export const TabButton = styled(PrimaryButton)<{ $active: boolean }>`
  --background: ${({ $active, theme }) => ($active ? theme.colors.joivy['teal-dark'] : theme.colors.joivy.white)};
  --text: ${({ $active, theme }) => ($active ? theme.colors.joivy.white : 'var(--gray-700, #344054)')};

  display: flex;
  padding: 0.625rem 1rem;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0;

  background: var(--background);
  color: var(--text);

  ${({ $active, theme }) => $active && `border: 1px solid ${theme.colors.joivy['teal-dark']} !important;`}

  @media screen and (max-width: 1160px) {
    .label {
      padding: 0.625rem 0.75rem;
      display: none;
    }
  }
`;
export const MobileMapContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
`;

export const WrapperVR = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;

  img,
  canvas {
    filter: brightness(0.8);
  }

  canvas {
    cursor: default;
  }

  & > * {
    grid-row: 1/-1;
    grid-column: 1/-1;
  }
`;

export const ButtonPlayVR = styled.button`
  display: flex;
  padding: 1rem 1.75rem;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  border-radius: 0.5rem;
  border: 1px solid var(--gray-300, #d0d5dd);
  background: var(--white, #fff);
  color: var(--Gray-700, #344054);

  /* Text xl/Bold */
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1.5;

  /* Shadow/xs */
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);

  cursor: pointer;

  z-index: 2;
`;

export const Desktop = styled.div<{ $fullScreen?: boolean }>`
  ${({ $fullScreen }) => ($fullScreen ? 'width: 100%; height: 100%;' : '')};

  @media screen and (max-width: 1160px) {
    display: none;
  }
`;
export const Mobile = styled.div<{ $fullScreen?: boolean }>`
  display: none;
  @media screen and (max-width: 1160px) {
    display: initial;
    ${({ $fullScreen }) => ($fullScreen ? 'width: 100%; height: 100%;' : '')};
  }
`;

export const BottomSheet = styled.div<{ $open: boolean }>`
  @media screen and (min-width: 1159px) {
    display: none;
  }

  --content-padding-inline: 0;
  --content-padding-block: 1.81rem;
  --animation: ${({ $open }) => ($open ? 'fade-in' : 'fade-out')};

  width: 100%;
  height: 100vh;
  height: 100dvh;
  background-color: ${({ theme }) => theme.colors.joivy.white};
  position: fixed;
  inset: 0;
  z-index: 99;
  animation: var(--animation) 0.4s cubic-bezier(0.36, 0.33, 0, 1);
  isolation: isolate;

  border-radius: var(--border-radius) var(--border-radius) 0 0;

  padding-inline: var(--content-padding-inline);

  @keyframes fade-in {
    0% {
      transform: translateY(100%);
    }

    100% {
      transform: translateY(0);
    }
  }

  @keyframes fade-out {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(100%);
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;
`;

export const BottomSheetHeader = styled.div`
  background: ${({ theme }) => theme.colors.joivy.white};
  padding: 1rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BottomSheetCloseButton = styled.button`
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  padding: 0.38rem;
  display: grid;
  place-items: center;
  border: none;
  background: none;
`;

export const BottomSheetContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;
